export default __webpack_public_path__ + "static/media/t35.3a4c76bf.jpg";